module.exports = __webpack_public_path__ + "static/img/work.3176545.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/work.jpg
// module id = vWMW
// module chunks = 0